let fbPromise = null;

export function loadFacebook(appId, version = "v18.0") {
  if (window.FB) return Promise.resolve(true);
  if (fbPromise) return fbPromise;
  fbPromise = new Promise((resolve) => {
    window.fbAsyncInit = () => {
      try {
        window.FB.init({ appId, cookie: false, xfbml: false, version });
        resolve(true);
      } catch {
        resolve(false);
      }
    };
    const s = document.createElement("script");
    s.async = true;
    s.defer = true;
    s.crossOrigin = "anonymous";
    s.src = "https://connect.facebook.net/en_US/sdk.js";
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return fbPromise;
}

export function fbLogin() {
  return new Promise((resolve) => {
    if (!window.FB) return resolve(null);
    window.FB.login((res) => resolve(res), { scope: "public_profile,email" });
  });
}
